import { render, staticRenderFns } from "./WithDrawalMethodDetialModal.vue?vue&type=template&id=561f3e52&scoped=true"
import script from "./WithDrawalMethodDetialModal.vue?vue&type=script&lang=js"
export * from "./WithDrawalMethodDetialModal.vue?vue&type=script&lang=js"
import style0 from "./WithDrawalMethodDetialModal.vue?vue&type=style&index=0&id=561f3e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f3e52",
  null
  
)

export default component.exports